//INSERT Own COMPS HERE
import { EventComponent } from './event/event';
import { EventExpandComponent } from './event/event-expand';
import { EventTabComponent } from './event/event-tab';
import { FactsComponent } from './facts/index';
import { FilterComponent } from './filter/index';
import { HeaderComponent } from './header/index';
import { IframeComponent } from './iframe/iframe';
import { InteractiveMapComponent } from './interactive-map/index';
import { MapExtendedComponent } from './map/index';
import { LanguageChooserComponent } from './language-chooser/language-chooser';
import { NavBackComponent } from './navbar/nav-back';
import { NavBreadcrumbComponent } from './navbar/nav-breadcrumb';
import { NavScrollComponent } from './navbar/nav-scroll';
import { NewsBackComponent } from './news/news-back';
import { NewsCategoryComponent } from './news/news-category';
import { SearchComponent } from './search/search';
import { SwiperComponent } from './swiper/swiper';
import { NavTogglerComponent } from './navbar/nav-toggler';
import { NavSkiplinkComponent } from './navbar/nav-skiplinks';
import { FocusOnComponent } from './focus-on/index';

export default [
	EventComponent,
	EventExpandComponent,
	EventTabComponent,
	FactsComponent,
	FilterComponent,
	HeaderComponent,
	IframeComponent,
	InteractiveMapComponent,
	LanguageChooserComponent,
	MapExtendedComponent,
	NavBackComponent,
	NavBreadcrumbComponent,
	NewsBackComponent,
	NewsCategoryComponent,
	SearchComponent,
	SwiperComponent,
	NavScrollComponent,
	NavTogglerComponent,
	NavSkiplinkComponent,
	FocusOnComponent
];
